import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import SvgChevronDown from '@img/icons/chevron-down-thin.svg?url';
import styled from 'styled-components';
import Button from '../../Buttons/Button/Button';
import ButtonStyles from '../../Buttons/Button/Button.styles';
const Container = styled.section `
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 22px;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Filter = styled.div `
  display: block;
  position: relative;
  margin-bottom: 15px;
`;
const SelectLabel = styled.label `
  ${srOnly};
`;
const FilterDropdown = styled.select `
  ${fonts.montserrat.medium};
  display: block;
  width: 100%;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  appearance: none !important;
  background: none;
  background-color: ${brand.white};
  background-image: url('${SvgChevronDown}');
  background-repeat: no-repeat;
  background-position: center right 12px;
  background-size: 16px 8px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 30px 0 12px;
  width: 100%;
`;
const FilterSection = styled.div `
  width: 100%;
`;
const FilterTop = styled.div `
  display: flex;
  gap: 5px 15px;
  width: 100%;
  flex-wrap: wrap;

  ${Filter} {
    flex: 1 0 auto;
    max-width: 100%;
  }

  ${FilterDropdown} {
    ${fonts.montserrat.bold};
    height: 48px;
    border: 2px solid ${brand.black};
    font-size: 15px;
    line-height: 20px;
    
  }
`;
const FilterBase = styled.div `
  background-color: ${brand.lightGrey};
  padding: 12px 20px;
  border-radius: 8px;
  text-align: center;
`;
const PageIndex = styled.span `
  font-size: 16px;
  line-height: 24px;
  flex: 7 0 auto;
`;
const Open = styled.button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  color: ${brand.black};
  height: 48px;
  margin: 0 0 0 auto;
  padding: 0 16px;
  flex: 1 0 auto;

  > svg {
    display: block;
    height: 14px;
    margin-left: 16px;
    width: 14px;
  }

  > span {
    ${fonts.montserrat.bold};
    font-size: 15px;
    line-height: 20px;
  }
`;
const Overlay = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  background: ${brand.white};
  height: 100%;
  transform: translateX(-100vw);
  transition: transform 0.3s ease-out;
  width: calc(100% - 48px);
  z-index: ${Layers.Modal};

  [aria-active='true'] & {
    transform: translateX(0vw);
  }
`;
const Close = styled.button `
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${brand.white};
  height: 48px;
  justify-content: center;
  margin: 0;
  padding: 0;
  transform: translateX(100%);
  width: 48px;

  > svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  > span {
    ${srOnly};
  }
`;
const Background = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  background: ${brand.black};
  height: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  width: 100%;
  z-index: ${Layers.Modal - 1};

  [aria-active='true'] & {
    opacity: 0.85;
    pointer-events: all;
  }
`;
const Title = styled.h2 `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  ${fonts.montserrat.extraBold};
  font-size: 20px;
  line-height: 28px;
  padding: 12px 0;
  margin-bottom: 12px;
`;
const SelectedFilters = styled.div `
  flex: 1 0 100%;
`;
const ItemList = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  padding: 20px;
`;
const FilterHolder = styled.span `
`;
const FilterSearch = styled.input `
  ${fonts.montserrat.medium};
  display: block;
  appearance: none;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  background-color: transparent;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 15px;  
  width: 100%;
`;
const FilterSearchBtn = styled(Button) `
  margin-top: 10px;
  height: 48px;
  text-align: center;
  justify-content: center;

  ${ButtonStyles.IconWrapper} {
    margin-right: 0;
  }
`;
export default {
    Background,
    Close,
    Container,
    Filter,
    FilterBase,
    FilterDropdown,
    FilterHolder,
    FilterSearch,
    FilterSearchBtn,
    FilterSection,
    FilterTop,
    ItemList,
    Open,
    Overlay,
    PageIndex,
    SelectedFilters,
    SelectLabel,
    Title,
};
